import React from 'react'
import Museos from '../components/services/museos'

const MuseosEs = () => {
  return <Museos lang='es' />
}
export default MuseosEs